import { Component } from '@angular/core';


export class SkyDefinitionListDemoComponent {
  public personalInfo: { label: string, value: string }[] = [
    {
      label: 'Job title',
      value: 'Engineer'
    },
    {
      label: 'Hobby',
      value: 'Volleyball'
    },
    {
      label: 'Experience',
      value: '3 years'
    }
  ];

  public systemInfo: { label: string, value?: string }[] = [
    {
      label: 'Username',
      value: 'user1'
    },
    {
      label: 'Role',
      value: 'Admin'
    },
    {
      label: 'Last log-in time'
    }
  ];
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-definition-list-demo',
  template: `<sky-definition-list>
  <sky-definition-list-heading>
    Personal information
  </sky-definition-list-heading>
  <sky-definition-list-content
    *ngFor="let item of personalInfo">
    <sky-definition-list-label>
      {{item.label}}
    </sky-definition-list-label>
    <sky-definition-list-value>
      {{item.value}}
    </sky-definition-list-value>
  </sky-definition-list-content>
</sky-definition-list>
<sky-definition-list
  labelWidth="150px"
  defaultValue="No information found">
  <sky-definition-list-heading>
    System information
  </sky-definition-list-heading>
  <sky-definition-list-content
    *ngFor="let item of systemInfo">
    <sky-definition-list-label>
      {{item.label}}
    </sky-definition-list-label>
    <sky-definition-list-value>
      {{item.value}}
    </sky-definition-list-value>
  </sky-definition-list-content>
</sky-definition-list>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
